export default __webpack_public_path__ + "static/media/promptPay3.903c57ea.png";